import useBem from '@indicia/use-bem';

import SurveyChoiceOption from '../../../../shared/models/survey/SurveyChoiceOption';
import { HabitRadioDetails } from './types';

type HabitRadioDetailsPropType = {
  onChange: (value: string) => void;
} & HabitRadioDetails;

const HabitRadio = ({ currentValue, questionKey, options, onChange }: HabitRadioDetailsPropType) => {
  const { bemClassName } = useBem('habit__radio');

  return (
    <div className={bemClassName()}>
      {options.map(({ id, description }: SurveyChoiceOption) => (
        <div
          key={`${questionKey}_${id}`}
          className={bemClassName('option')}
        >
          <input
            type="radio"
            name={questionKey}
            id={`${questionKey}_${id}`}
            value={id}
            checked={currentValue === id}
            onChange={() => onChange(id)}
          />
          <label htmlFor={`${questionKey}_${id}`}>{description}</label>
        </div>
      ))}
    </div>
  );
};

export default HabitRadio;
